import StyledAxlMultiSelect from "../../../../components/StyledAxlMultiSelect";
import React from "react";
import * as Reports from "../../reportStyles";
import { styles } from "./styles";
import {withStyles} from "@material-ui/core";


export const SERVICE_LEVEL_DEFAULT = "";

const ServiceLevel = ({ handleOnChange, values, name, serviceLevels }) => {
    
    const handleChangeServiceLevel = (value) => {
        const serviceLevels = value && value.length > 0 ? value.map(r => r.value) : SERVICE_LEVEL_DEFAULT;
        handleOnChange(name, serviceLevels);        
    }

    const serviceLevelValue = values ? serviceLevels.filter(rg => values.includes(rg.value)) : undefined;
    return (
        <Reports.GroupField style={{textAlign: 'left'}}>
            <Reports.Label>{`for`}</Reports.Label>
            <StyledAxlMultiSelect
                defaulValue={serviceLevelValue && serviceLevels.filter(option => serviceLevels.indexOf(option.value) >= 0) }
                placeholderButtonLabel="all service levels"
                showValues={false}
                allowAll={true}
                onChange={handleChangeServiceLevel}
                placeholder="Search service level…"
                options={serviceLevels}
                isSearchable={true}
            />
        </Reports.GroupField>
    )     
    
}
export default withStyles(styles)(ServiceLevel);
